import { ViewController } from '@estee/elc-service';
import { ZoomViewBaseController } from './ZoomViewBaseController';

export class ProductZoomButtonViewController extends ViewController {
    private zoomViewBaseController: ZoomViewBaseController;

    constructor(zoomViewBaseController: ZoomViewBaseController) {
        super();
        this.zoomViewBaseController = zoomViewBaseController;
    }

    public openZoomByIndex = (index: number = 0) => {
        const { setCurrentZoomSlideIndex, openZoom } = this.zoomViewBaseController;

        setCurrentZoomSlideIndex(index);
        openZoom();
    };

    public closeZoom = () => {
        this.zoomViewBaseController.closeZoom();
    };
}
